import React, {Component} from "react";

export class WooCommerceLogo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isHovered: false
        };
    }

    getRenderVeryColoredVersion() {
        if(this.props.renderVeryColoredVersion)
            return this.props.renderVeryColoredVersion;
        return false;
    }

    getIsColoredOnHover() {
        if(this.props.isColoredOnHover)
            return this.props.isColoredOnHover;
        return false;
    }

    handleMouseEnter = () => {
        this.setState({ isHovered: true });
    }

    handleMouseLeave = () => {
        this.setState({ isHovered: false });
    }

    getHeight() {
        if(this.props.height)
            return this.props.height;
        return 30;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return 30;
    }

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    getFillColor() {
        if(this.getRenderVeryColoredVersion())
            return "#96588A";
        if(this.getIsColoredOnHover() && !this.state.isHovered)
            return "#B6B6B7";
        return "#96588A";
    }

    getTextColor() {
        if(this.getRenderVeryColoredVersion())
            return "white";
        if(this.getIsColoredOnHover() && !this.state.isHovered)
            return "white";
        return "white";
    }

    render() {
        const style = {
            ...this.props.styles,
            marginRight: this.getHSpace(),
            marginTop: this.getVSpace(),
            marginBottom: this.getVSpace(),
        };

        return (
            <svg
                viewBox="0 0 100 100"
                height={this.getHeight()}
                width={this.getWidth()}
                style={style}
                aria-label="WooCommerce"
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                <rect width="100" height="100" rx="15" fill={this.getFillColor()}/>
                <text x="50" y="68" textAnchor="middle" fill={this.getTextColor()} fontSize="55" fontWeight="bold" fontFamily="Arial, sans-serif">W</text>
            </svg>
        );
    }
}
